/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWithVehicle56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        d='M21.141 19.967l-1.485.206.647 4.67h-3.295v1.5h5.017l-.884-6.376z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M18.472 8.681c-5.97 0-10.81 4.84-10.81 10.81v4.733c0 3.67 1.83 6.911 4.623 8.864l-.014.02.045.03-.14.785a2.8 2.8 0 01-1.789 2.134L4.385 38.27A5.842 5.842 0 00.563 43.75h1.5a4.341 4.341 0 012.84-4.074l4.133-1.523a13.139 13.139 0 009.436 3.98c3.7 0 7.043-1.525 9.435-3.98l4.134 1.523a4.341 4.341 0 012.84 4.074h1.5a5.841 5.841 0 00-3.822-5.481l-6.003-2.212a2.8 2.8 0 01-1.788-2.133l-.145-.811a10.798 10.798 0 004.658-8.89V19.49c0-5.97-4.84-10.809-10.81-10.809zm-.888 26.108c-1.768-.19-3.01-.554-3.876-.913l-.056.312a4.3 4.3 0 01-2.746 3.277l-.309.113a11.631 11.631 0 007.875 3.055c3.034 0 5.797-1.157 7.874-3.055l-.308-.113a4.3 4.3 0 01-2.746-3.277l-.323-1.796.43-.269a9.302 9.302 0 004.382-7.9V19.49c0-1.805-.514-3.49-1.403-4.916-.582.458-1.288.783-2.03 1.014-1.086.337-2.324.496-3.55.547-2.451.103-4.976-.22-6.408-.527l.314-1.466c1.33.285 3.726.59 6.03.494 1.152-.048 2.25-.196 3.169-.481.659-.205 1.189-.468 1.581-.787A9.309 9.309 0 009.163 19.49v4.733a9.302 9.302 0 004.381 7.899l.128.08c.697.371 1.94.866 4.072 1.094l-.16 1.492z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M38.277 15.796h-4.863v-1.5h4.863c.92 0 1.778.46 2.288 1.225l3.43 5.143 8.602 2.15a3.75 3.75 0 012.84 3.639v6.077h-8.433a4.237 4.237 0 01-8.34 0h-7v-1.5h7a4.238 4.238 0 018.34 0h6.934v-2.478h-2.696a.75.75 0 010-1.5h2.696v-.6a2.25 2.25 0 00-1.705-2.182L43.44 22.07h-8.275v-1.5h6.966l-2.813-4.219a1.25 1.25 0 00-1.04-.556zm4.557 13.248a2.736 2.736 0 100 5.473 2.736 2.736 0 000-5.473z'
      />
    </svg>
  );
}

export default SvgWithVehicle56;
